import React, { useState, useEffect, Fragment } from 'react';
import { Asset } from '@archetypes'
import { ProgressBar } from "@components"
import styled from "styled-components"


const ProgressBarWrapper = styled.div`
    height: 4px;
    width: 100%; 
    margin: 0 auto;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 2px;
    overflow: visible;
`

const Base = styled.div`
    width: 100%;
    height: 100%;
`

const Progress = styled(Base)`
    color: white;
    text-align: center;
    line-height: 75px;
    font-size: 35px;
    font-family: "Segoe UI";
    animation-direction: reverse;
    background: #e5405e;

    /* Chrome10-25,Safari5.1-6 */
    background: ${props => props.background && `${props.background}`};

`
// danger : background: linear-gradient(to right, #e5405e 0%, #ffdb3a 45%, #3fffa2 100%);
// safe : background: linear-gradient(to right, #2980B9 0%, #6DD5FA 45%, #FFFFFF 100%);
// warning : background: linear-gradient(to right, #19DED1 0%, #FFD705 100%);

const Shrinker = styled(Base)`
    background-color: black;
    position: absolute;
    top: 0;
    right: 0;
    width: ${props => props.value && `${props.value}%`};
`

const Line = styled.div`
    height: 10px;
    position: absolute;
    top: -3px;
    z-index: 999;
    overflow: visible;
    opacity: 0.7;
`

const DottedLine = styled.div`
    height: 24px;
    position: absolute;
    top: 0px;
    z-index: 999;
    overflow: visible;
    opacity: 0.7;
`

const DangerLine = styled(Line)`
    border-left: 3px solid #FF7A65;
    left: ${props => props.value && `${props.value}%`};
`

const SafeLine = styled(Line)`
    border-left: 3px solid #BCD7F6;
    left: ${props => props.value && `${props.value}%`};
`

const DangerDottedLine = styled(DottedLine)`
    border-left: 3px dotted #FF7A65;
    left: ${props => props.value && `${props.value}%`};
`

const FloatingText = styled.div`
    position: absolute;
    top: 5px;
    z-index: 999;
    overflow: visible; 
    color: #FF7A65;
    font-size: 12px;
    left: ${props => props.value && `${props.value - 20}%`};
`

const SafeDottedLine = styled(DottedLine)`
    border-left: 3px dotted #BCD7F6;
    left: ${props => props.value && `${props.value}%`};
`


// styled doesn't work on some components by unknown reason
const CollateralRatio = styled(
    ({ className, position, myPosition }) => {

        let cr_current
        let cr_minimum
        let expired
        let minified = position ? true : false
        if (position) {
            cr_current = position?.cr_current
            cr_minimum = Number(position?.cr_minimum) * 100
            expired = position?.expired
        } else if (myPosition) {
            cr_current = myPosition?.actualCurrentRatio 
            cr_minimum = Number(myPosition?.requiredRatio) * 100
            expired = myPosition?.expired
        }

        const currentRatio = (Number(cr_current) * 100).toFixed(0)
        const minimumRatio = (Number(cr_minimum)).toFixed(0)
        const dangerRatio = minimumRatio > 100 ? Math.floor(minimumRatio * 1.2) : Math.floor(minimumRatio * 1.4)
        const safeRatio = Math.floor(dangerRatio * 1.25)


        // Reformatting to 0-100%
        const reformatting = (value) => {
            let newValue = value > 50 ? Math.floor((value - 50) / Math.ceil(currentRatio / 100) + 1) : 0
            newValue = newValue > 100 ? 100 : newValue
            return newValue
        }

        const currentValue = reformatting(currentRatio)
        const dangerValue = reformatting(dangerRatio)
        const safeValue = reformatting(safeRatio)

        let gradientBg
        if (currentValue >= safeValue) {
            // safe
            gradientBg = "linear-gradient(to right, #2980B9 0%, #6DD5FA 45%, #FFFFFF 100%)"
        } else if (currentValue >= dangerValue) {
            // warning
            gradientBg = "linear-gradient(to right, #19DED1 0%, #FFD705 100%)"
        } else {
            // danger
            gradientBg = "linear-gradient(to right, #e5405e 0%, #ffdb3a 45%, #3fffa2 100%)"
        }

        return (
            <div className={className} style={{ display: "flex", flexDirection: "column", marginTop: minified ? "0px" : "3rem" }}>
                <div style={{ flexDirection: "row", display: "flex", paddingBottom: "1rem" }}>
                    {minified
                        ? <div style={{ flex: 1 }}>
                            {currentRatio}%
                         </div>
                        : <div className="-ratio-info">
                            <h4>Collateral Ratio</h4>
                            <p>{currentRatio}%</p>
                        </div>

                    }
                    <div style={{ flex: 1, display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                        <Asset.Position.RatioBadge
                            expired={expired}
                            current={currentValue}
                            minimum={dangerValue}
                            safe={safeValue}
                        />
                    </div>

                </div>
                <ProgressBarWrapper>
                    <Progress
                        background={gradientBg}
                    />
                    <Shrinker
                        value={100 - currentValue}
                    />
                    {minified
                        ?
                        <>
                            <DangerLine
                                value={dangerValue}
                            />
                            <SafeLine
                                value={safeValue}
                            />
                        </>
                        :
                        <>
                            <DangerDottedLine
                                value={dangerValue}
                            />
                            <FloatingText value={dangerValue}>
                                MIN {cr_minimum.toFixed(0)}%
                            </FloatingText>

                            <SafeDottedLine
                                value={safeValue}
                            />
                        </>
                    }

                </ProgressBarWrapper>
            </div>
        )
    })`
    .-data:after {
        content: "";
        display: table;
        clear: both;

        >div { 
            float: right;
            width: 50%;
            :first-child {
                float: left;
            }
        }
    }

    .-ratio-info {
        font-weight: 600;
        h4 {
            font-size: 14px;
            color: var(--color-label, lightblue);
            margin: 0px;
            line-height: 18px;
        }
        p {
            font-size: 18px;
            color: var(--color-white);
            margin: 0px;
            line-height: 30px;
        }
    }

    .-data {
        padding-bottom: 1rem;
    }


    `

export default CollateralRatio